import { React, useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import EuroSystemModal from "./EuroSystemModal";
import EuroConfirmationModal from "../../components/setup_modals/EuroConfirmationModal";
const EuroCheckModal = ({ data, isOpen, toggle, assessmentStarted, setAssessmentStarted }) => {
  const [isConfirmSetting, setIsConfirmSetting] = useState(false);
  const [IsconfirmCondition, setIsconfirmCondition] = useState(false);
  const [IsconfirmAttempt, setIsconfirmAttempt] = useState(false);
  

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="modal-dialog-centered subscription-modal-lg"
      backdrop="static"
    >
      <ModalBody className="px-0 py-3" data-tc="system-requirement-modal">
        <EuroSystemModal data={data} assessmentStarted={assessmentStarted} toggle={toggle} />
        <EuroConfirmationModal
          data={data} 
          assessmentStarted={assessmentStarted}
          toggle={toggle}
          setAssessmentStarted={setAssessmentStarted}
          setisConfirmSetting={setIsConfirmSetting}
          isConfirmSetting={isConfirmSetting}
          setIsconfirmCondition={setIsconfirmCondition}
          IsconfirmCondition={IsconfirmCondition}
          setIsconfirmAttempt={setIsconfirmAttempt}
          IsconfirmAttempt={IsconfirmAttempt}
        />
      </ModalBody>
    </Modal>
  );
};

EuroCheckModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

EuroCheckModal.defaultProps = {
  isOpen: false,
};

export default EuroCheckModal;
